import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  websocket: WebSocket | undefined;
  public webSocketMessage: any[] = [];
  private userRequest: string | undefined;

  constructor() {
  }

  openWebSocketConnection(url: string) {


    this.websocket = new WebSocket(url);


    this.websocket.onopen = (e) => {
    }

    this.websocket.onmessage = (e) => {
      let msgObject = {
        userRequest: this.userRequest,
        userResponse: e.data
      }
      this.webSocketMessage.push(msgObject);
      this.userRequest = undefined;
    }

    this.websocket.onerror = (e) => {
      console.log(e)
    }

    this.websocket.onclose = (e) => {
      console.log(e);
    }
  }

  sendWebSocketMessage(msg: string) {
    if (this.websocket != undefined) {
      this.websocket.send(msg);
      this.userRequest = msg;
    }

  }

  closeWebSocketConnection() {
    if (this.websocket != undefined)
      this.websocket.close();
  }

}
